import React, { FunctionComponent } from 'react';
import { FormControl, FormHelperText, Grid, NativeSelect } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

type FieldMathTypeProps = {
    error: boolean;
    onChange: (object: any) => void;
    value: number;
    formHelperText: string;
};

function cmp(prev: FieldMathTypeProps, cur: FieldMathTypeProps): boolean {
    return prev.error === cur.error && prev.formHelperText === cur.formHelperText && prev.value === cur.value;
}

const FieldMathType: FunctionComponent<FieldMathTypeProps> = React.memo(({ error, onChange, value, formHelperText }) => {
    const [t] = useTranslation();
    return <Grid item xs={12} sm={3}>
        <FormControl error={error} fullWidth size="small">
            <NativeSelect onChange={onChange} value={value}>
                <option value={0}>{t('ru.halls.selectors.maladaptive')}</option>
                <option value={1}>{t('ru.halls.selectors.old')}</option>
                <option value={3}>{t('ru.halls.selectors.playtech')}</option>
                <option value={4}>{t('ru.halls.selectors.adaptive')}</option>
            </NativeSelect>
            <FormHelperText> {formHelperText} </FormHelperText>
        </FormControl>
    </Grid>;
}, cmp);

export default FieldMathType;